document.addEventListener('DOMContentLoaded', function () {
  const sizeSelect = document.getElementById('ring-size-select');
  const errorMsg = document.getElementById('ring-size-error');
  const instagramInput = document.getElementById('instagram-handle');

  if (!sizeSelect) return;

  // Réinitialise l'erreur quand on choisit une taille
  sizeSelect.addEventListener('change', function () {
    if (this.value) {
      errorMsg.style.display = 'none';
      sizeSelect.style.borderColor = '#77917F';
    }
  });

  // Intercepte TOUS les formulaires d'ajout au panier de la page
  document.addEventListener('submit', function (e) {
    const form = e.target;

    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    // Blocage si pas de taille choisie
    if (!sizeSelect.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      errorMsg.style.display = 'block';
      sizeSelect.style.borderColor = '#77917F';
      sizeSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Ajoute la propriété "Taille de bague"
    let sizeHidden = form.querySelector('input[name="properties[💍 Taille de bague ]"]');
    if (!sizeHidden) {
      sizeHidden = document.createElement('input');
      sizeHidden.type = 'hidden';
      sizeHidden.name = 'properties[💍 Taille de bague ]';
      form.appendChild(sizeHidden);
    }
    sizeHidden.value = sizeSelect.value;

    // Ajoute la propriété "Instagram" SEULEMENT si remplie
    if (instagramInput && instagramInput.value.trim()) {
      let igHidden = form.querySelector('input[name="properties[📸 Instagram ]"]');
      if (!igHidden) {
        igHidden = document.createElement('input');
        igHidden.type = 'hidden';
        igHidden.name = 'properties[📸 Instagram ]';
        form.appendChild(igHidden);
      }
      let value = instagramInput.value.trim();
      if (!value.startsWith('@')) value = '@' + value;
      igHidden.value = value;
    }
  }, true);
});
document.addEventListener('DOMContentLoaded', function () {
  const sizeSelect = document.getElementById('ring-size-select');
  if (!sizeSelect) return;

  function applyPaymentButtonState() {
    const dynamicCheckout = document.querySelector('[data-shopify="payment-button"]');
    if (!dynamicCheckout) return;
    const hasSize = sizeSelect.value !== '';
    dynamicCheckout.style.opacity = hasSize ? '1' : '0.4';
    dynamicCheckout.style.pointerEvents = hasSize ? '' : 'none';
  }

  const observer = new MutationObserver(function () {
    const dynamicCheckout = document.querySelector('[data-shopify="payment-button"]');
    if (dynamicCheckout) {
      applyPaymentButtonState();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  sizeSelect.addEventListener('change', applyPaymentButtonState);
});

window.addEventListener('pagehide', function () {
  const dynamicCheckout = document.querySelector('[data-shopify="payment-button"]');
  if (dynamicCheckout) {
    dynamicCheckout.style.opacity = '';
    dynamicCheckout.style.pointerEvents = '';
  }
});
window.addEventListener('pageshow', function (event) {
  if (!window.location.pathname.includes('/collections/')) return;
  if (window.innerWidth >= 750) return;

  const scrollPos = sessionStorage.getItem('collectionScrollPos');
  if (scrollPos) window.scrollTo(0, parseInt(scrollPos));
});

document.addEventListener('click', function (e) {
  if (window.innerWidth >= 750) return;
  if (!window.location.pathname.includes('/collections/')) return;
  const link = e.target.closest('a[href*="/products/"]');
  if (link) sessionStorage.setItem('collectionScrollPos', window.scrollY);
});
